import { SessionChange, MagicConfigMixin, ModalMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { ACCOUNT_PEP_BLOCK_QUERY } from '@gig/magic-messages';
import { importResponsibleGaming } from '../../../utils/helpers.js';

/**
 * The Limit Confirmation Prompter periodically (on login) checks for
 * limits that must be confirmed by the user. When limits are required
 * to be confirmed it will open the specified modal with the list of limits.
 */
var ConfirmationPrompterComponent = /** @class */ (function (_super) {
    __extends(ConfirmationPrompterComponent, _super);
    function ConfirmationPrompterComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        return _this;
    }
    ConfirmationPrompterComponent.prototype.render = function () {
        return null;
    };
    ConfirmationPrompterComponent.prototype.sessionChange = function (isLoggedIn) {
        if (isLoggedIn) {
            this.fetchLimits();
            return;
        }
        this.closeModal();
    };
    ConfirmationPrompterComponent.prototype.fetchLimits = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isPepBlocked, awaiting, modalElement;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(ACCOUNT_PEP_BLOCK_QUERY)];
                    case 1:
                        isPepBlocked = _a.sent();
                        if (isPepBlocked) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, magic.invokeCached(60, magic.methods.responsibleGaming, 'awaitingUserLimitsConfirmation')()];
                    case 2:
                        awaiting = _a.sent();
                        if (!(awaiting.length > 0 && !this.hasModal())) return [3 /*break*/, 4];
                        return [4 /*yield*/, importResponsibleGaming()];
                    case 3:
                        _a.sent();
                        modalElement = this.openModal(this.renderedModal, this.header || null, {
                            dismissible: false,
                            keepAfterClear: true,
                        });
                        modalElement.addEventListener('confirmed', function () {
                            _this.closeModal();
                        });
                        modalElement.unconfirmedLimits = awaiting;
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Prop({
            type: String,
            default: 'magic-limit-confirmation-prompt',
        }),
        __metadata("design:type", String)
    ], ConfirmationPrompterComponent.prototype, "renderedModal", void 0);
    __decorate([
        Prop({
            type: String,
            default: null,
        }),
        __metadata("design:type", Object)
    ], ConfirmationPrompterComponent.prototype, "header", void 0);
    __decorate([
        SessionChange({ immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], ConfirmationPrompterComponent.prototype, "sessionChange", null);
    ConfirmationPrompterComponent = __decorate([
        Component({
            name: 'limit-confirmation-prompter',
        })
    ], ConfirmationPrompterComponent);
    return ConfirmationPrompterComponent;
}(Mixins(MagicConfigMixin, ModalMixin)));

export default ConfirmationPrompterComponent;
